import Vue from 'vue';

export default {
    beforeCreate() {
        if (this.$options.syncProps) {
            const syncProps = this.$options.syncProps;
            const attrs = Object.keys(this.$attrs);

            this.$options.computed = this.$options.computed ?? {};

            for (const key of syncProps) {
                if (!attrs.includes(key)) {
                    Vue.util.warn(`Missing sync-prop "${key}"`, this);
                }

                this.$options.computed[key] = {
                    get() { return this.$attrs[key] },
                    set(value) { this.$emit(`update:${key}`, value) },
                };
            }
        }
    },
};
